<template>
  <component :is="rootTag" class="icon-image-container" v-bind="rootProps">
    <div
      class="icon-image-wrap"
      :class="[
        {
          cover: !message.image_size || message.image_size === 'crop',
          fill: message.image_size === 'stretch'
        }
      ]"
      @click="action"
    >
      <img :src="message.image" @load="$emit('image-loaded')" />
      <span v-if="message.buttonText" class="text icon-message-image" :style="computedIconColors">
        {{ message.buttonText }}
      </span>
    </div>
    <slot name="close"></slot>
  </component>
</template>

<script>
import { hexToRgbA } from 'Utilities'
import Plain from './Plain.vue'
import { useIconMessageStore } from 'Store/icon-message'
import { useChatStore } from 'Store/chat'

export default {
  extends: Plain,

  data() {
    return {
      iconMessageStore: useIconMessageStore(),
      chatStore: useChatStore()
    }
  },

  computed: {
    computedIconColors() {
      return {
        backgroundColor: hexToRgbA(this.message.backgroundColor, '0.8'),
        color: this.message.textColor
      }
    }
  },

  methods: {
    action() {
      this.$gtag.recordIconMessageClicked(this.message)

      if (this.message.url) {
        this.trackMetrics('click')
        return
      }

      this.openChat()
      this.chatStore.sendIconAutoMessage(this.message)

      if (this.message.segment_ids) {
        this.trackMetrics('click')
      }
    }
  }
}
</script>
